
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 20 27.706","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M19.5 27.206H.5v-19h7v1h-6v17h17v-17h-6v-1h7v19zm-9-9.5h-1V2.592L6.214 5.884 5.5 5.175 9.969.706 14.5 5.175l-.714.709L10.5 2.646v15.06z","fill":"#007aff","data-name":"Action 2"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      